import React from "react";
import { Box } from "@mui/material";
import { assetImages } from "../../constants/assets";

const BackgroundContainer = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        // background: `linear-gradient(to bottom, ${darkColors.backgroundTop}, ${darkColors.backgroundBottom})`,
        color: "white",
        display: "flex",
        overflow: "hidden",
        position: "relative",
        backgroundSize: "cover",
        backgroundImage: `url(${assetImages.heroImage})`,

        // "&::before": {
        //   content: '""',
        //   position: "absolute",
        //   top: 0,
        //   left: 0,
        //   width: { xl: "35%", lg: "55%", md: "60%", xs: "100%" },
        //   height: "100%",
        //   backgroundImage: `url(${assetImages.vector})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   opacity: 0.08,
        //   zIndex: 0,
        // },
        // "&::after": {
        //   content: '""',
        //   position: "absolute",
        //   top: 0,
        //   right: 0,
        //   width: { lg: "50%", md: "55%" },
        //   height: "100%",
        //   backgroundImage: `url(${assetImages.heroBgImage})`,
        //   backgroundSize: "cover",
        //   opacity: 1,
        //   zIndex: 0,
        // },
      }}
    >
      {children}
    </Box>
  );
};

export default BackgroundContainer;
